import {  useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Image from "next/image";
import style from "@/styles/Questions.module.scss"; // Adjust the import to your actual stylesheet path
import { useRouter } from "next/router";

const WhyChoose = ({ WhyChooseUs }: any) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  
  const router = useRouter();

  const imageArray = [
    {
      Images: {
        default: "/assets/icons/scalable.svg",
        hover: "/assets/icons/scalable-hover.svg"
      }
    },
    {
      Images: {
        default: "/assets/icons/model.svg",
        hover: "/assets/icons/model-hover.svg"
      }
    },
    {
      Images: {
        default: "/assets/icons/integration.svg",
        hover: "/assets/icons/integration-hover.svg"
      }
    },
    {
      Images: {
        default: "/assets/icons/continous.svg",
        hover: "/assets/icons/continous-hover.svg"
      }
    }
  ];


  return (
    <div className={style.whyChoose}>
      <Container
        className=" w-100 bg-light-gray  pt-104"
        id="section3"
        fluid={true}
      >
        <Row className="margin-xx mb-64">
          <Col xs={12} lg={12} md={12} xl={6} className="">
            <h2 className="text">{WhyChooseUs?.Title}</h2>
          </Col>
          <Col xs={12} lg={12} md={12} xl={6} className="">
            <p className="text-description m-0">{WhyChooseUs?.ShortDescription}</p>
          </Col>
        </Row>
        <div className="h-5 margin-xx">
          <div
            className={"backgroundSection"}
            style={{
              backgroundImage: `url(${WhyChooseUs?.Image?.data?.attributes?.url})`,
            }}
          >
            <Container
              fluid={true}
              className="mt-2 container-card"
              // style={{ paddingTop: "152px", paddingBottom: "8px", paddingLeft: "0", paddingRight:"0"}}
            >
              <div className={"cardContainer"}>
                {WhyChooseUs?.Collections?.map((item: any, index: number) => (
                  <Card
                    className={"card"} style={{width:"calc(25%-8px)"}}
                    key={index}
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                  >
                    <Card.Body className={"cardBody"}>
                    <Image
                  src={hoveredIndex === index ? imageArray[index]?.Images?.hover : imageArray[index]?.Images?.default}
                  width={48}
                  height={48}
                  alt={`Image ${index + 1}`}
                  className="cardImage"
                />
                      <Card.Title>{item.Title}</Card.Title>
                      <Card.Text>{item?.SubTitle}</Card.Text>
                    </Card.Body>
                  </Card>
                ))}
              </div>
            </Container>
          </div>
        </div>

        <div
          className={`${style.buttonAnimate} gap-3 d-flex justify-content-start bottom-know-more`}
        >
          <span>Who are we? How do we help business find solution?</span>
          <Button className="animated-button know-more" onClick={()=> router.push("/about-us/")}>
            Know more about us
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default WhyChoose;
